import React from 'react';
import { Row, Col } from 'antd';
import {Link} from "react-router-dom";

function Footer() {
  return (
    <footer id="footer" className="allButFooter">
      <Row className="bottom-bar">
        <Col lg={6} sm={24} />
        <Col lg={18} sm={24}>
          <span
              className="text-white"
            style={{
              lineHeight: '16px',
              marginRight: 5
            }}
          >
            Institute or Enterprise?
          </span>
          <span className="text-white" style={{ marginRight: 24 }}>
            <a href="mailto:contact@paradi.io"
              rel="noopener noreferrer"
              target="_blank"
            >
              Contact us
            </a>
          </span>
          <span className="text-white" style={{ marginRight: 12 }}>Copyright © IBIS Solutions, Inc.</span>
          <Link to="/privacy-policy" className="text-white" style={{ marginRight: 12 }}>Privacy Policy</Link>
        </Col>
      </Row>
    </footer>
  );
}


export default Footer;
